export const STATUS_META = {
  draft: { label: "Draft", color: "bg-slate-700 text-slate-200 border-slate-600" },
  safety_complete: { label: "Safety Complete", color: "bg-blue-900/40 text-blue-300 border-blue-700" },
  field_complete: { label: "Field Complete", color: "bg-indigo-900/40 text-indigo-300 border-indigo-700" },
  testing_complete: { label: "Testing Complete", color: "bg-cyan-900/40 text-cyan-300 border-cyan-700" },
  photo_complete: { label: "Photo Complete", color: "bg-sky-900/40 text-sky-300 border-sky-700" },
  ready_for_review: { label: "Ready For Review", color: "bg-amber-900/40 text-amber-300 border-amber-700" },
  approved: { label: "Approved", color: "bg-emerald-900/40 text-emerald-300 border-emerald-700" },
  closed: { label: "Closed", color: "bg-slate-800 text-slate-400 border-slate-700" },
};

// Shown in the "New Project" form, project header, photo-template
// filters, etc. The order here is the order users see in the dropdown.
// "Microwave" is intentionally first so it stays the default selection.
//
// Legacy values (microwave_install, router_install, fiber_install,
// tower_modification, maintenance, other) are kept in the backend
// Literal so historical projects still load, but they are NOT in this
// list — users can no longer pick them for new projects.
export const PROJECT_TYPES = [
  { value: "microwave", label: "Microwave" },
  { value: "raw_land", label: "Raw Land" },
  { value: "colo", label: "Colo" },
  { value: "tower_stack", label: "Tower Stack" },
  { value: "tower_owner_cop", label: "Tower Owner COP" },
  { value: "civil", label: "Civil" },
  { value: "electrical", label: "Electrical" },
  { value: "pano_ai", label: "Pano AI" },
  { value: "pano_site_audit", label: "Pano AI Site Audit" },
  { value: "site_audit", label: "Site Audit" },
  { value: "site_survey", label: "Site Survey" },
  { value: "safety_only", label: "Safety Only" },
];

// Friendly display for legacy project_type values that may still appear
// on old project records. Anything not in this map falls back to a
// title-cased version of the raw machine value.
export const LEGACY_PROJECT_TYPE_LABELS = {
  microwave_install: "Microwave (legacy)",
  router_install: "Router Install (legacy)",
  fiber_install: "Fiber Install (legacy)",
  tower_modification: "Tower Modification (legacy)",
  maintenance: "Maintenance (legacy)",
  other: "Other (legacy)",
};

export function projectTypeLabel(value) {
  const found = PROJECT_TYPES.find((t) => t.value === value);
  if (found) return found.label;
  if (LEGACY_PROJECT_TYPE_LABELS[value]) return LEGACY_PROJECT_TYPE_LABELS[value];
  if (!value) return "—";
  return value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export const ROLE_META = {
  technician: { label: "Technician" },
  foreman: { label: "Foreman" },
  pm: { label: "Project Manager" },
  admin: { label: "Administrator" },
};

export const PPE_OPTIONS = [
  "Hard Hat",
  "Safety Glasses",
  "Steel-Toed Boots",
  "Gloves",
  "High-Vis Vest",
  "Fall Protection Harness",
  "RF Awareness Monitor",
  "Hearing Protection",
];

// Pre-canned rescue plans the field crew can drop into the Rescue Plan field
// with one tap on the Tailgate / JSA forms. Add more entries here as your
// crews standardize additional scenarios.
export const RESCUE_PLAN_TEMPLATES = [
  {
    id: "basic",
    name: "Basic Rescue Plan",
    text:
      "Rescuer will rig above victim to a 5,000lbs anchor point; utilize the " +
      "Petzl ID by attaching to the rescue rope. Descend to the appropriate " +
      "height to attach the ID to the available back or front D-ring. Using " +
      "the carabiner purposed for connecting the ID to D-ring. Once " +
      "connected, place the ID in the lock position and transfer the full " +
      "weight to the Rescue system. Once transferred use the ID to maintain " +
      "a controlled decent to safety.",
  },
];

export const HAZARD_TEMPLATES = [  {
    name: "Tower Climbing",
    hazards: ["Fall from height", "Dropped tools", "Weather", "Fatigue"],
    mitigations: ["100% tie-off", "Tool lanyards", "Climb plan", "Weather check"],
  },
  {
    name: "Rigging",
    hazards: ["Suspended loads", "Pinch points", "Equipment failure"],
    mitigations: ["Inspect rigging", "Clear drop zone", "Communicate load path"],
  },
  {
    name: "Electrical",
    hazards: ["Shock", "Arc flash", "Energized circuits"],
    mitigations: ["LOTO", "Verify de-energized", "Use insulated tools"],
  },
  {
    name: "RF Exposure",
    hazards: ["RF radiation", "Heating effects"],
    mitigations: ["Coordinate sector shutdown", "Wear RF monitor", "Maintain distance"],
  },
  {
    name: "Fiber Optics",
    hazards: ["Laser exposure", "Glass shards", "Chemicals"],
    mitigations: ["Power off laser", "Eye protection", "Proper disposal"],
  },
  {
    name: "Traffic Control",
    hazards: ["Moving vehicles", "Visibility"],
    mitigations: ["Cones & signage", "High-vis PPE", "Spotter"],
  },
  {
    name: "Weather",
    hazards: ["Lightning", "High winds", "Heat / cold stress"],
    mitigations: ["Monitor radar", "Suspend climb >25mph", "Hydration breaks"],
  },
];
